import { useAssistantStream } from '@/components/assistant/useAssistantStream';
import { AssistantPanel } from '@/components/assistant/AssistantChat';

const SUGGESTIONS = [
  'Summarise this ticket',
  'What should I do next?',
  'Draft a reply to the customer',
] as const;

/**
 * Collapsible AI helper for the ticket detail page, with a pop-out modal for a fuller view.
 * Streams a Claude reply (via the server's Foundry-backed `/api/assistant/stream` SSE
 * endpoint) about the open ticket. The server fetches authoritative ticket context with the
 * user's impersonation, so the panel only needs the ticket id.
 */
export function TicketAssistant({ ticketId }: { ticketId: number }) {
  const chat = useAssistantStream({
    endpoint: '/api/assistant/stream',
    body: () => ({ ticketId }),
    resetKey: ticketId,
  });

  return (
    <AssistantPanel
      chat={chat}
      suggestions={SUGGESTIONS}
      suggestionsLabel="Ask about this ticket:"
      placeholder="Ask about this ticket…"
    />
  );
}
